import axios from "axios";
import AxiosInstance1 from "../AxiosInstance/AxiosInstance1";

const GetInitiativeWorkFlow = async (IdeaId) => {
  const accessToken = sessionStorage.getItem("access_token");
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;

  try {
    const response = await AxiosInstance1.get(
      `/api/InitiativeDetail/GetInitiativeWorkFlow`,
      {
        params: { IdeaId }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching initiative cost list:", error);
    throw new Error("Failed to fetch initiative cost list");
  }
};

export default GetInitiativeWorkFlow;
